import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {NgOption, NgSelectComponent} from '@ng-select/ng-select';


@Component({
    selector: 'lib-rc-autocomplete',
    template: `<div class="form-group rc-autocomplete-wrapper" id="{{autocompleteId}}" #autocompleteWrapper
     [ngClass]="{'is-invalid': control && control.invalid && control.dirty, 'have-value': control && control.value && control.value.toString().length, 'disabled': isDisabled() }">
  <div>
    <ng-select [items]="items"
               #ngSelect
               [dropdownPosition]="dropdownPosition"
               bindValue="key"
               bindLabel="value"
               labelForId="{{'inner-' + autocompleteId}}"
               [(ngModel)]="selectedValue"
               [disabled]="isDisabled()"
               [multiple]="multiple"
               [isOpen]="isOpen()"
               placeholder="{{placeHolder}}"
               [searchable]="autocomplete && !readonly"
               (focus)="onFocus($event)"
               (blur)="onBlur($event)"
               (clear)="onClear($event)"
               (change)="onChange($event)"
               [notFoundText]="notFoundText"
               [maxlength]="maxlength"
               (close)="onClose($event)"
               [clearable]="clearable">
    </ng-select>
    <div role="alert" *ngIf="errorMsg" class="invalid-feedback-message">{{ errorMsg }}</div>
  </div>
</div>
`,
    styles: [``]
})
export class RcAutoCompleteComponent implements AfterViewInit {
    @ViewChild(NgSelectComponent) ngSelect: NgSelectComponent;

    @Input() placeHolder: string;
    @Input() control: FormControl;
    @Input() errorMsg: string;
    @Input() readonly: boolean;
    @Input() idValue: string;
    @Input() error: string;
    @Input() loading: boolean;
    @Input() required: boolean;
    @Input() autocomplete = true;
    @Input() freeText: boolean = false;
    @Input() multiple: boolean = false;
    @Input() maxlength: number;
    @Input() notFoundText: string = 'No items found';
    @Input() clearable = true;
    @Input() items: NgOption[] = [];
    @Input() autocompleteId: string;
    @Input() label: string;
    @Input() dropdownPosition: string = 'auto';
    @Output() selectionChangeCallback: EventEmitter<any> = new EventEmitter();
    @Output() inputChangeCallback: EventEmitter<any> = new EventEmitter();
    @Output() inputFocusCallback: EventEmitter<any> = new EventEmitter();
    @Output() inputBlurCallback: EventEmitter<any> = new EventEmitter();
    @Output() inputCloseCallback: EventEmitter<any> = new EventEmitter();


    constructor() {
    }

    ngAfterViewInit(): void {
        if (this.freeText) {
            if (this.control.value) {
                const items = this.items.filter((tmpItem) => {
                    return tmpItem.key === this.control.value;
                });
                if (items.length === 0) {
                    this.ngSelect.filterValue = this.control.value;
                }
            }
        }
    }

    get selectedValue(): any {
        return this.control.value;
    }

    set selectedValue(val) {
        this.control.setValue(val);
    }

    isOpen() {
        if (!this.freeText) {
            return null;
        }
        return (<any>this.ngSelect.itemsList)._filteredItems.length > 0 ? null : false;
    }

    /**
     * on focus - emit event if received
     * @param event
     */
    onFocus(event): void {
        if (this.inputFocusCallback.observers.length) {
            this.inputFocusCallback.emit();
        }
    }

    /**
     * on blur - emit event if received
     * @param event
     */
    onBlur(event): void {
        if (this.freeText) {
            if (!this.filteredItems.length) {
                this.control.setValue(this.filterValue);
            }
        }
        if (this.inputBlurCallback.observers.length) {
            this.inputBlurCallback.emit();
        }
    }

    get filterValue() {
        return this.ngSelect.filterValue;
    }

    get filteredItems() {
        return (<any>this.ngSelect.itemsList)._filteredItems;
    }

    /**
     * on clear - emit selection change with null selected value to changeCallback
     * @param event
     */
    onClear(event): void {
        this.selectionChangeCallback.emit({key: null, value: null});
    }

    /**
     * on close - emit selection change with null selected value to changeCallback
     * @param event
     */
    onClose(event): void {
        if (this.inputCloseCallback.observers.length) {
            this.inputCloseCallback.emit(event);
        }

    }

    /**
     * on change event
     * @param event
     */
    onChange(event): void {

        if (!this.multiple) {
            this.control.setValue(event ? event.key : null);
        }

        if (this.inputChangeCallback.observers.length) {
            this.inputChangeCallback.emit(event);
        }
    }

    /**
     * is disabled
     * @returns boolean
     */
    isDisabled(): boolean {
        return this.control ? this.control.disabled : false;
    }

}
